"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ReportContext = (0, react_1.createContext)({ type: 'dollar' });
exports.default = ReportContext;
